var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgDashboardtile3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 99,
    viewBox: "0 0 273 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_185_515)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273,
    height: 99,
    fill: "url(#paint0_linear_185_515)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 217.984,
    width: 251.609,
    height: 218.083,
    rx: 22,
    transform: "rotate(-60.0382 52 217.984)",
    fill: "url(#paint1_linear_185_515)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.1992,
    y: 200.845,
    width: 192.718,
    height: 190.549,
    rx: 22,
    transform: "rotate(-60.0382 90.1992 200.845)",
    fill: "url(#paint2_linear_185_515)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_185_515",
    x1: -68,
    y1: -41.1169,
    x2: 248.56,
    y2: 242.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_185_515",
    x1: 81.9526,
    y1: 172.951,
    x2: 84.8872,
    y2: 384.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23E976",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_185_515",
    x1: 329.504,
    y1: 268.349,
    x2: 135.275,
    y2: 267.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11F4AC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215637",
    stopOpacity: 0.12
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_185_515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 273,
    height: 99,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDashboardtile3);
export default __webpack_public_path__ + "static/media/BG-DASHBOARDTILE-3.bd37270e76818aafb4f25ebdc0b7d9ff.svg";
export { ForwardRef as ReactComponent };